// https://it.wikipedia.org/wiki/ISO_639
// ftp://ftp.fu-berlin.de/doc/iso/iso3166-countrycodes.txt
export default {
  it_it: {
    ISO639: 'it',
    ISO3166_1: 'IT',
    ISO3166_2: 'ITA',
  },
  fr_fr: {
    ISO639: 'fr',
    ISO3166_1: 'FR',
    ISO3166_2: 'FRA',
  },
  es_es: {
    ISO639: 'es',
    ISO3166_1: 'ES',
    ISO3166_2: 'ESP',
  },
  es_mx: {
    ISO639: 'es',
    ISO3166_1: 'MX',
    ISO3166_2: 'MEX',
  },
  pt_br: {
    ISO639: 'pt',
    ISO3166_1: 'BR',
    ISO3166_2: 'BRA',
  },
  id_id: {
    ISO639: 'id',
    ISO3166_1: 'ID',
    ISO3166_2: 'IND',
  },
  en_au: {
    ISO639: 'en',
    ISO3166_1: 'AU',
    ISO3166_2: 'AUS',
  },
  en_nz: {
    ISO639: 'en',
    ISO3166_1: 'NZ',
    ISO3166_2: 'NZL',
  },
  en_us: {
    ISO639: 'en',
    ISO3166_1: 'US',
    ISO3166_2: 'USA',
  },
  ro_ro: {
    ISO639: 'ro',
    ISO3166_1: 'RO',
    ISO3166_2: 'ROU',
  },
  bg_bg: {
    ISO639: 'bg',
    ISO3166_1: 'BG',
    ISO3166_2: 'BGR',
  },
  cs_cz: {
    ISO639: 'cs',
    ISO3166_1: 'CZ',
    ISO3166_2: 'CZE',
  },
  pt_pt: {
    ISO639: 'pt',
    ISO3166_1: 'PT',
    ISO3166_2: 'PRT',
  },
  es_cl: {
    ISO639: 'es',
    ISO3166_1: 'CL',
    ISO3166_2: 'CHL',
  },
  es_ar: {
    ISO639: 'es',
    ISO3166_1: 'AR',
    ISO3166_2: 'ARG',
  },
  es_co: {
    ISO639: 'es',
    ISO3166_1: 'CO',
    ISO3166_2: 'COL',
  },
  es_ec: {
    ISO639: 'es',
    ISO3166_1: 'EC',
    ISO3166_2: 'ECU',
  },
  es_pe: {
    ISO639: 'es',
    ISO3166_1: 'PE',
    ISO3166_2: 'PER',
  },
  fr_be: {
    ISO639: 'fr',
    ISO3166_1: 'BE',
    ISO3166_2: 'BEL',
  },
  nl_be: {
    ISO639: 'nl',
    ISO3166_1: 'BE',
    ISO3166_2: 'BEL',
  },
  en_za: {
    ISO639: 'en',
    ISO3166_1: 'ZA',
    ISO3166_2: 'ZAF',
  },
  en_gb: {
    ISO639: 'en',
    ISO3166_1: 'GB',
    ISO3166_2: 'GBR',
  },
  en_ca: {
    ISO639: 'en',
    ISO3166_1: 'CA',
    ISO3166_2: 'CAN',
  },
  tr_tr: {
    ISO639: 'tr',
    ISO3166_1: 'TR',
    ISO3166_2: 'TUR',
  },
  de_de: {
    ISO639: 'de',
    ISO3166_1: 'DE',
    ISO3166_2: 'DEU',
  },
  de_at: {
    ISO639: 'de',
    ISO3166_1: 'AT',
    ISO3166_2: 'AUT',
  },
  nb_no: {
    ISO639: 'no',
    ISO3166_1: 'NO',
    ISO3166_2: 'NOR',
  },
  nl_nl: {
    ISO639: 'nl',
    ISO3166_1: 'NL',
    ISO3166_2: 'NLD',
  },
  da_dk: {
    ISO639: 'da',
    ISO3166_1: 'DK',
    ISO3166_2: 'DNK',
  },
  sv_se: {
    ISO639: 'sv',
    ISO3166_1: 'SE',
    ISO3166_2: 'SWE',
  },
  de_ch: {
    ISO639: 'de',
    ISO3166_1: 'CH',
    ISO3166_2: 'CHE',
  },
  el_gr: {
    ISO639: 'el',
    ISO3166_1: 'GR',
    ISO3166_2: 'GRC',
  },
  pl_pl: {
    ISO639: 'pl',
    ISO3166_1: 'PL',
    ISO3166_2: 'POL',
  },
  sk_sk: {
    ISO639: 'sk',
    ISO3166_1: 'SK',
    ISO3166_2: 'SVK',
  },
  hu_hu: {
    ISO639: 'hu',
    ISO3166_1: 'HU',
    ISO3166_2: 'HUN',
  },
  fi_fi: {
    ISO639: 'fi',
    ISO3166_1: 'FI',
    ISO3166_2: 'FIN',
  },
  zh_sg: {
    ISO639: 'zh',
    ISO3166_1: 'SG',
    ISO3166_2: 'SGP',
  },
  ko_kr: {
    ISO639: 'ko',
    ISO3166_1: 'KR',
    ISO3166_2: 'KOR',
  },
  ar_sa: {
    ISO639: 'ar',
    ISO3166_1: 'SA',
    ISO3166_2: 'SAU',
  },
  ar_ae: {
    ISO639: 'ar',
    ISO3166_1: 'SA',
    ISO3166_2: 'SAU',
  },
  ar_ma: {
    ISO639: 'ar',
    ISO3166_1: 'MA',
    ISO3166_2: 'MAR',
  },
  jp_jp: {
    ISO639: 'jp',
    ISO3166_1: 'JP',
    ISO3166_2: 'JPN',
  },
}
